import Pusher from 'pusher-js';

const createNoopPusher = (): Pusher =>
  ({
    subscribe: () =>
      ({
        bind: () => undefined,
        bind_global: () => undefined,
        unbind: () => undefined,
      }) as any,
    unsubscribe: () => undefined,
    disconnect: () => undefined,
  }) as Pusher;

const pusherKey = import.meta.env.VITE_APP_PUSHER_APP_KEY;
const pusherCluster = import.meta.env.VITE_APP_PUSHER_APP_CLUSTER;
const pusherEndpoint = import.meta.env.VITE_APP_ENGENI_API_URL;

export const pusher =
  pusherKey && pusherCluster
    ? new Pusher(pusherKey, {
        cluster: pusherCluster,
        channelAuthorization: {
          endpoint: `${pusherEndpoint}/cxm/broadcasting/auth`,
          transport: 'ajax',
          headersProvider() {
            return {
              Authorization: `Bearer ${localStorage.getItem('access_token')}`,
            };
          },
        },
      })
    : createNoopPusher();
